import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  main: {
    display: 'flex',
    flexGrow: 1,
    // maxWidth: 'calc(100% - 170px)',
    flexDirection: 'column',
    width: '100%',
  },
  tree: {
    position: 'relative',
  },
  dropdown: {
    position: 'absolute',
    zIndex: 1,
    top: 36,
    right: 0,
    width: 'calc(100% - 170px)',
    minWidth: 200,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.26), 0px 10px 20px rgba(0, 0, 0, 0.19)',
    borderRadius: 4,
  },
  inputWide: {
    width: '100%',
    flexGrow: 1,
    height: 36,
    borderRadius: 4,
    backgroundColor: '#fff',
    padding: theme.spacing(0, 2),
  },
}));
